export default __webpack_public_path__ + "contentmodules/UCS_Sign_In_Audience-colorfb3c2b2936cb35067ba2cf87cff1a48d.png";